export const FAQS = [
  {
    title: "How complex is the move from AWS or Azure to MOST?",
    content:
      "We automate most tasks using proven tooling and provide rollback assurance — reducing risk and time to deploy.",
  },
  {
    title: "Will we need to reconfigure security groups or IAM?",
    content:
      "MOST allows custom RBAC and ACL configurations and supports network policies that mirror your existing setup.",
  },
  {
    title: "Does MOST support infrastructure-as-code?",
    content:
      "Yes, we support Terraform, Ansible, and GitOps-style deployments with native OpenStack APIs.",
  },
  {
    title: "Can we run both VM and container workloads?",
    content:
      "Absolutely — MOST can integrate with OneMind PaaS for Kubernetes-based container orchestration.",
  },
  {
    title: "How is support handled post-migration?",
    content:
      "OneMind offers 24/7 support, monitoring, patching, and resource tuning as part of our managed services.",
  },
  {
    title:
      "Can we migrate only specific workloads instead of the entire cloud environment?",
    content:
      "Yes. OneMind supports phased or partial migrations, allowing you to move selected workloads (e.g., dev/test environments, specific applications) to MOST while keeping the rest on public cloud.",
  },
  {
    title: "How do you handle database migrations during the transition?",
    content:
      "We support database migration using native tools like AWS DMS, Azure Database Migration Service, and dump/restore methods. We ensure schema compatibility and transactional consistency during cutover.",
  },
  {
    title: "Is it possible to replicate our S3 storage to MOST object storage (Swift)?",
    content:
      "Yes. Object storage replication from S3 to Swift is supported using tools like rclone, s3cmd, or native APIs. We also assist in mapping access policies and lifecycle rules.",
  },
  {
    title: "Will we retain visibility into infrastructure performance post-migration?",
    content:
      "Absolutely. MOST includes built-in observability using Grafana, Prometheus, and Elastic Stack, giving you real-time insights into CPU, memory, network, and application health.",
  },
  {
    title: "How does MOST handle compliance and data residency requirements?",
    content:
      "MOST supports tenant isolation, encrypted volumes, role-based access control (RBAC), and regional deployment flexibility to meet GDPR, HIPAA, and other compliance frameworks.",
  },
];
